import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
export function sendColonistRushTimerStarted() {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.ColonistRushTimerStarted,
        category: AnalyticEventCategory.Lobby
    });
}
export function sendColonistRushTimerPlayed(secondsOnPage) {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.ColonistRushTimerPlayed,
        category: AnalyticEventCategory.Lobby,
        floatValue: secondsOnPage
    });
}
